import React, { useEffect, useState, useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
const MUSIC_URL = 'https://cdn.magicpatterns.com/uploads/reCqxokA1FfjyGJyPqQ7U5/MUSICA_EL_MIRADOR.mp3';
interface MusicToggleProps {
  /** Tailwind classes controlling the icon/border colors for the current header state */
  variant?: 'light' | 'dark';
}
export function MusicToggle({
  variant = 'dark'
}: MusicToggleProps) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    const audio = new Audio(MUSIC_URL);
    audio.loop = true;
    audio.volume = 0.4;
    audioRef.current = audio;
    // Keep state in sync with the actual element so the icon never lies.
    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    audio.addEventListener('play', onPlay);
    audio.addEventListener('pause', onPause);
    // Try to autoplay; if the browser blocks it, the user starts it with the button.
    audio.play().catch(() => {});
    return () => {
      audio.removeEventListener('play', onPlay);
      audio.removeEventListener('pause', onPause);
      audio.pause();
      audioRef.current = null;
    };
  }, []);
  const toggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  };
  const isLight = variant === 'light';
  return <button type="button" onClick={toggle} aria-label={isPlaying ? 'Pausar música' : 'Reproducir música'} title={isPlaying ? 'Pausar música' : 'Reproducir música'} className={`flex items-center justify-center w-10 h-10 rounded-full border bg-transparent transition-colors ${isLight ? 'border-white/50 text-white hover:bg-white/10' : 'border-olive/40 text-olive hover:bg-olive/10'}`} data-id="element-204">
      {isPlaying ? <Volume2 size={20} data-id="element-205" /> : <VolumeX size={20} data-id="element-206" />}
    </button>;
}